import { render, staticRenderFns } from "./UserPicture.vue?vue&type=template&id=168fcd32&lang=pug&"
import script from "./UserPicture.vue?vue&type=script&lang=js&"
export * from "./UserPicture.vue?vue&type=script&lang=js&"
import style0 from "./UserPicture.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports